// @flow

// Effect Managers
import { fork } from 'redux-saga/effects'

// Sagas
import watchUpdateSeason from './updateSeason'
import setDefaultSeason from './defaultSeason'

export default function *main (): Generator<*, *, *> {
  yield fork(watchUpdateSeason)
  yield fork(setDefaultSeason)
}
